import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionDirective } from './has-permission.directive';
import { CountDown } from './countdown.directive';

@NgModule({
  imports: [CommonModule],
  exports: [HasPermissionDirective, CountDown],
  declarations: [HasPermissionDirective, CountDown]
})
export class ComponentesModule {}
